﻿export class ConsignmentDelivery {
	public ConsignmentId!: string;
	public DeliveryDate!: string;
	public MRNo!: string;
	public MRAmount!: number;
	public DDRChartNo!: string;
	public DelUID!: number;
	public IsDeliver!: boolean;
	public CN_DTDCHG!: number;
}
